import React from 'react'
import { motion } from 'framer-motion'
import { Section } from './ui'
import { cn } from '../utils'

const BrandStorySection: React.FC = () => {
  return (
    <Section id="meaning" background="default" padding="lg">
      <motion.div
        className="max-w-3xl mx-auto text-center"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      >
        <p className="text-xs font-medium tracking-[0.22em] uppercase text-primary-600 dark:text-primary-300 mb-6">
          The Meaning of MATNO
        </p>
        <h2
          className={cn(
            'text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] mb-8',
            'text-gray-900 dark:text-white'
          )}
        >
          MATNO means{' '}
          <span className="relative inline-block">
            <span className="text-primary-500 dark:text-primary-300 italic">'how.'</span>
            <span
              aria-hidden="true"
              className="absolute -bottom-1 left-0 right-0 h-[3px] bg-primary-400/60 dark:bg-primary-400/50 rounded-full"
            />
          </span>
        </h2>
        <p className="text-lg md:text-xl text-gray-600 dark:text-gray-300 leading-relaxed">
          For us, <span className="text-gray-900 dark:text-white font-medium">how</span> is
          the question behind every transformation: how can Africa use knowledge, data, AI,
          and human capital to build better systems, stronger institutions, and shared
          prosperity?
        </p>
      </motion.div>
    </Section>
  )
}

export default BrandStorySection
